import url from './url';



export default url(({ roleId = ':roleId' }) => `/rbac/roles/${roleId}`);
